import { useTranslation } from "react-i18next";
import { ModalButtonsWrap } from "../Modals/styles";
import Button from "../UI/Button";
import Modal from "../UI/Modal/Modal";
import TextModalHeading from "../UI/Typography/TextModalHeading";
import TextRegularGrey from "../UI/Typography/TextRegularGrey";
import { IModalProps } from "./types";
import { useKeysModal } from "../../hooks/useKeysModal";
import { useKeyCustomization } from "../../hooks/useKeyCustomization";

const ModalDeleteKey = ({ onClose }: IModalProps) => {
  const { t } = useTranslation();
  const { deletionId } = useKeysModal();
  const { removeKeyById } = useKeyCustomization();

  const onConfirm = () => {
    if (deletionId) {
      removeKeyById(deletionId);
    }
    onClose();
  };

  return (
    <Modal
      onClose={onClose}
      maxWidth='480px'
      width='100%'
    >
      <TextModalHeading
        sx={{ marginBottom: '32px' }}
      >
        {t('modal.delete-key.title')}
      </TextModalHeading>

      <TextRegularGrey sx={{ marginBottom: '32px' }}>
        {t('modal.delete-key.text')}
      </TextRegularGrey>

      <ModalButtonsWrap>
        <Button
          sx={{
            width: '122px',
          }}
          onClick={onClose}
          variant='second'
        >
          {t('modal.cancel')}
        </Button>
        <Button
          sx={{
            width: '100%',
          }}
          onClick={onConfirm}
        >
          {t('modal.delete')}
        </Button>
      </ModalButtonsWrap>
    </Modal>
  )
};

export default ModalDeleteKey;